import { Exception } from '@core/exceptions/exception';

export class RefreshTokenNotFoundException extends Exception {
  constructor(message = 'The refresh token is not found.') {
    super(message);
  }
}
